import { NgTemplateOutlet } from "@angular/common";
import {
    Component,
    contentChild,
    EventEmitter,
    Input,
    Output,
    TemplateRef,
    ViewChild,
    ChangeDetectionStrategy
} from "@angular/core";
import { asapScheduler, BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";
import { ITab, TabState } from "./itab";

@Component({
    selector: "rask-tab",
    styleUrls: ["./tab.component.scss"],
    templateUrl: "./tab.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgTemplateOutlet]
})
export class TabComponent implements ITab {
    @Input() label: string;
    @Input() routeId: string;
    @Input() disabled: boolean;
    @Input() tabId?: any;
    @Input() lockedTab = false;
    @Input() tooltipText = "";
    @Input() icon? = "";
    @Input() iconColorType? = "";
    @Input() iconColor? = "";
    @Input() iconPosition: "left" | "right" = "left";
    @Input() spinner = false;
    @Input() ignoreIconClick = false;

    @Input() canDeactivate?: () => Promise<boolean>;

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onTabSelected = new EventEmitter();
    gotBody = true;

    @Output() state$ = new BehaviorSubject<TabState>("unvisited");
    protected readonly contentTemplateRef = contentChild("tabContent", { read: TemplateRef });

    get visited() {
        return this.state$.value !== "unvisited";
    }
    get visited$() {
        return this.state$.pipe(map(x => x !== "unvisited"));
    }

    private _template: TemplateRef<any>;
    get template() {
        return this._template;
    }

    @ViewChild("template")
    set template(template: TemplateRef<any>) {
        asapScheduler.schedule(() => {
            this._template = template;
        });
    }

    deactivate(): Promise<boolean> {
        if (this.canDeactivate) {
            return this.canDeactivate();
        }
        return Promise.resolve(true);
    }

    dispatchEvent() {

        // todo fixa event går raka vägen från parent till childs
        // this.template.elementRef.nativeElement.dispatchEvent(new Event("onShow"));
        document.dispatchEvent(new Event("onShow"));
    }
}
